import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const partnerBenefits = [
    {
        number: '01',
        title: 'Differentiate',
        description:
            'Add a new software capability without building the cognitive intelligence stack in-house.',
    },
    {
        number: '02',
        title: 'Personalize',
        description:
            'Create experiences that respond to what the user’s mind is doing in the moment.',
    },
    {
        number: '03',
        title: 'Extend',
        description:
            'Bring cognitive intelligence to familiar head-worn form factors such as earbuds, headphones and future wearable designs.',
    },
];

const DeviceMakers = () => {
    return (
        <section
            id="device-makers"
            className="relative overflow-hidden bg-[#05070b] py-24 text-white sm:py-28"
        >
            {/* Background atmosphere */}
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute right-[-180px] top-1/3 h-[550px] w-[650px] rounded-full bg-[#3157ff]/[0.035] blur-[160px]" />
            </div>

            <div className="relative z-10 mx-auto max-w-[1400px] px-8">

                {/* Heading */}
                <div className="max-w-[900px]">
                    <div className="mb-6 flex items-center gap-3 text-[11px] tracking-[0.28em] text-neutral-500">
                        <span className="h-px w-8 bg-neutral-600" />
                        FOR DEVICE MAKERS
                    </div>

                    <h2 className="text-[40px] font-semibold leading-[1.03] tracking-[-0.04em] sm:text-[52px] lg:text-[60px]">
    <span className="text-neutral-500">
        Keep the devices people already love.
    </span>
                        <br />
                        Add the intelligence.
                    </h2>

                    <p className="mt-6 max-w-[720px] text-[16px] leading-[1.7] text-neutral-400 sm:text-[17px]">
                        FroCort is building an intelligence layer for head-worn
                        products such as earbuds and headphones. We work toward
                        integrating brain-sensing and AI capabilities into the
                        products people already know and wear.
                    </p>
                </div>

                {/* Important clarification */}
                <div className="mt-10 max-w-[820px] rounded-2xl border border-[#8ea5ff]/15 bg-[#10162a]/50 px-6 py-5 sm:px-7">
                    <div className="text-[10px] uppercase tracking-[0.24em] text-[#8ea5ff]">
                        The idea
                    </div>

                    <p className="mt-3 text-[15px] leading-[1.7] text-neutral-300 sm:text-[16px]">
                        FroCort is not another consumer device people need to
                        buy and wear. The long-term goal is to bring cognitive
                        intelligence into familiar wearable form factors
                        through compatible sensing hardware and our software
                        layer.
                    </p>
                </div>

                {/* Value */}
                <div className="mt-14">
                    <div className="mb-6 text-[11px] uppercase tracking-[0.24em] text-neutral-500">
                        What FroCort adds
                    </div>

                    <div className="grid grid-cols-1 gap-px overflow-hidden rounded-[26px] border border-white/10 bg-white/10 md:grid-cols-3">

                        {partnerBenefits.map((benefit) => (
                            <article
                                key={benefit.number}
                                className="min-h-[220px] bg-[#05070b] p-7 sm:p-8"
                            >
                                <div className="text-[10px] tracking-[0.24em] text-neutral-600">
                                    {benefit.number}
                                </div>

                                <h3 className="mt-10 text-[23px] font-medium tracking-[-0.02em]">
                                    {benefit.title}
                                </h3>

                                <p className="mt-3 max-w-[360px] text-[13px] leading-[1.7] text-neutral-500">
                                    {benefit.description}
                                </p>
                            </article>
                        ))}

                    </div>
                </div>

                {/* Partnership statement */}
                <div className="mt-12 flex flex-col gap-7 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">

                    <div className="max-w-[720px]">
                        <p className="text-[19px] font-medium leading-[1.45] tracking-[-0.02em] text-neutral-300 sm:text-[22px]">
                            We provide the intelligence layer.
                            <span className="text-neutral-600">
                                {' '}You keep the hardware, brand and customer relationship.
                            </span>
                        </p>
                    </div>

                    <Link
                        to="/for-device-makers"
                        className="group inline-flex shrink-0 items-center gap-2 text-[14px] font-medium text-white transition-colors hover:text-[#8ea5ff]"
                    >
                        Explore the device-maker approach
                        <ArrowUpRight
                            size={16}
                            className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                        />
                    </Link>

                </div>

            </div>
        </section>
    );
};

export default DeviceMakers;